import { carouselItems } from '@/mocks/homepage';

export default function CarouselSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          重磅策划 · 深度报道 · 全网独家网红内幕大揭秘
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href={item.link}
              onClick={(e) => handleClick(e, item.link)}
              className="group relative rounded-2xl overflow-hidden cursor-pointer aspect-[16/7] bg-background-200"
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-background-950/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold mb-2">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-bold text-background-50 font-heading mb-1">{item.title}</h3>
                <p className="text-xs md:text-sm text-background-200">{item.subtitle}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}